import DownloadState from './DownloadState';
import {AnyAction} from 'redux';
import {ServerHolder} from './components/DownloadMain';
import {ThunkDispatch} from 'redux-thunk';
import {Destination} from '../../../integration/representation/contract';
import {FeatureTypeIdWithValidOperations, Operation} from '../../../integration/representation/feature';
import * as angular from 'angular';
import {FeatureTypeSummary} from '../../../integration/representation/feature-type';

export enum DownloadActionType {
    SET_CURRENT_USER,
    SET_DATACATALOG,
    SET_ROAD_OBJECT_TYPES,
    SET_ROAD_OBJECTS,
    SET_DESTINATION,
    SET_USE_PROJECT_REF,
    SET_USE_CONTRACT_PROJECT_REF,
    SET_CONTRACT_PROJECT_REF,
    SET_CUSTOM_PROJECT_REF,
    SET_SOSI_FOR_NVDB_123,
    SET_OPERATIONS,
    SET_SRID,
    SET_SELECTED_ROAD_OBJECT_TYPE_IDS,
    SET_LOADING,
    SET_LOADING_FEATURES,
    SET_LOADING_CONTRACT,
}

export type DownloadThunk = (dispatch: ThunkDispatch<DownloadState, ServerHolder, AnyAction>, getState: () => DownloadState, serverHolder: ServerHolder) => void;


const showErrorMessage = (message: string): DownloadThunk => (dispatch, getState, serverHolder) => {
    serverHolder.scope.$applyAsync(() =>
        serverHolder.server.messages.danger(message)
    );
};
const showWarningMessage = (message: string): DownloadThunk => (dispatch, getState, serverHolder) => {
    serverHolder.scope.$applyAsync(() =>
        serverHolder.server.messages.warning(message)
    );
};
const showInfoMessage = (message: string): DownloadThunk => (dispatch, getState, serverHolder) => {
    serverHolder.scope.$applyAsync(() =>
        serverHolder.server.messages.info(message)
    );
};

export type InitDownload = (contractId: string) => DownloadThunk;
export const initDownload: InitDownload = (contractId) => (dispatch, getState, serverHolder) => {

    serverHolder.security.ensureCurrentUser()
        .then(user => {
            dispatch({
                type: DownloadActionType.SET_CURRENT_USER,
                currentUser: user
            });
        });

    dispatch(setDatacatalog());
    dispatch(setFeatureTypes(contractId));
    dispatch(setProjectRef(contractId));
    dispatch(setFeatures(contractId));
};

type SetDatacatalog = () => DownloadThunk;
const setDatacatalog: SetDatacatalog = () => (dispatch, getState, serverHolder) => {
    dispatch({
        type: DownloadActionType.SET_DATACATALOG,
        datacatalog: serverHolder.datacatalog
    });
};

export type SetLoading = (loading: boolean) => DownloadThunk;
export const setLoading: SetLoading = (loading) => (dispatch, getState, serverHolder) => {
    dispatch({
        type: DownloadActionType.SET_LOADING,
        loading
    });

};



type SetProjectRef = (contractId: string) => DownloadThunk;
const setProjectRef: SetProjectRef = (contractId) => async (dispatch, getState, serverHolder) => {
    dispatch(setLoadingContract(true));
    try {
        const result = await serverHolder.server.readContract(contractId);
        const referenceId = result.referenceId;

        dispatch({
            type: DownloadActionType.SET_CONTRACT_PROJECT_REF,
            contractProjectRef: referenceId
        });
    } catch (e) {

    } finally {
        dispatch(setLoadingContract(false));
    }

};


type GetFeatureTypes = (contractId: string) => DownloadThunk;
const setFeatureTypes: GetFeatureTypes = (contractId) => async (dispatch, getState, serverHolder) => {
    try {
        const result = await serverHolder.server.getFeatureTypeSummary(contractId);

        dispatch({
            type: DownloadActionType.SET_ROAD_OBJECT_TYPES,
            featureTypes: result
        });
    }
    catch (e) {
        // Handle error
    }
};


export type SetLoadingFeatures = (loading: boolean) => DownloadThunk;
export const setLoadingFeatures: SetLoadingFeatures = (loading) => (dispatch, getState, serverHolder) => {
    dispatch({
        type: DownloadActionType.SET_LOADING_FEATURES,
        loadingFeatures: loading
    });
};

export type setLoadingContract = (loading: boolean) => DownloadThunk;
export const setLoadingContract: setLoadingContract = (loading) => (dispatch, getState, serverHolder) => {
    dispatch({
        type: DownloadActionType.SET_LOADING_CONTRACT,
        loadingContract: loading
    });
};

type SetFeatures = (contractId: string) => DownloadThunk;
const setFeatures: SetFeatures = (contractId) => async (dispatch, getState, serverHolder) => {
    dispatch(setLoadingFeatures(true))
    try {
        const result = await serverHolder.server.readFeatures(contractId, null);
        dispatch({
            type: DownloadActionType.SET_ROAD_OBJECTS,
            features: result.features
        });
    } catch (e) {
        // Handle error
    } finally {
        dispatch(setLoadingFeatures(false))
    }
};

export type SetDestination = (destination: Destination) => DownloadThunk;
export const setDestination: SetDestination = (destination) => async (dispatch, getState, serverHolder) => {
    dispatch(emptySelectedFeatureTypeIds());
    dispatch({
        type: DownloadActionType.SET_DESTINATION,
        destination
    });
};


export type SetUseProjectRef = (useProjectRef: boolean) => DownloadThunk;
export const setUseProjectRef: SetUseProjectRef = (useProjectRef) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: DownloadActionType.SET_USE_PROJECT_REF,
        useProjectRef
    });
};

export type SetUseContractProjectRef = (useContractProjectRef: boolean) => DownloadThunk;
export const setUseContractProjectRef: SetUseContractProjectRef = (useContractProjectRef) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: DownloadActionType.SET_USE_CONTRACT_PROJECT_REF,
        useContractProjectRef
    });
};


export type SetContractProjectRef = (contractProjectRef: string) => DownloadThunk;
export const setContractProjectRef: SetContractProjectRef = (contractProjectRef) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: DownloadActionType.SET_CONTRACT_PROJECT_REF,
        contractProjectRef
    });
};


export type SetCustomProjectRef = (customProjectRef: string) => DownloadThunk;
export const setCustomProjectRef: SetCustomProjectRef = (customProjectRef) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: DownloadActionType.SET_CUSTOM_PROJECT_REF,
        customProjectRef
    });
};


export type SetSosiForNvdb123 = (sosiForNvdb123: boolean) => DownloadThunk;
export const setSosiForNvdb123: SetSosiForNvdb123 = (sosiForNvdb123) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: DownloadActionType.SET_SOSI_FOR_NVDB_123,
        sosiForNvdb123
    });
};


export type SetOperations = (operations: Operation[]) => DownloadThunk;
export const setOperations: SetOperations = (operations) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: DownloadActionType.SET_OPERATIONS,
        operations
    });
};


export type SetSrid = (srid: string) => DownloadThunk;
export const setSrid: SetSrid = (srid) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: DownloadActionType.SET_SRID,
        srid
    });
};

type EmptySelectedFeatureTypeIds = () => DownloadThunk;
const emptySelectedFeatureTypeIds: EmptySelectedFeatureTypeIds = () => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: DownloadActionType.SET_SELECTED_ROAD_OBJECT_TYPE_IDS,
        selectedFeatureTypeIds: []
    });
};

export type ToggleSelectedFeatureTypeIds = (typeId: number) => DownloadThunk;
export const toggleSelectedFeatureTypeIds: ToggleSelectedFeatureTypeIds = (typeId) => async (dispatch, getState, serverHolder) => {

    const state = getState();

    const selectedTypes = state.selectedFeatureTypeIds.slice(0);   // clone

    const indexOfTypeId = selectedTypes.indexOf(typeId);

    if (indexOfTypeId === -1) {
        // typeId not selected from before. Add to list.
        selectedTypes.push(typeId);
    } else {
        // typeId selected from before. Remove from list.
        selectedTypes.splice(indexOfTypeId, 1);
    }

    dispatch({
        type: DownloadActionType.SET_SELECTED_ROAD_OBJECT_TYPE_IDS,
        selectedFeatureTypeIds: selectedTypes
    });
};


export type NotifyOutdatedFeatureAttributes = (featureTypeId: number, featureTypes: FeatureTypeSummary[]) => DownloadThunk;
export const notifyOutdatedFeatureAttributes: NotifyOutdatedFeatureAttributes = (featureTypeId, featureTypes) => async (dispatch, getState, serverHolder) => {

    const contractId = serverHolder.contractId;

    serverHolder.server.getOutdatedFeatureAttributes(contractId, featureTypeId).then(function (outdated) {

        const featureType = featureTypes.find((type => type.typeid === featureTypeId));

        const outdatedItems: string[] = [];

        angular.forEach(outdated, function (attrTypeIds, featureName) {
            outdatedItems.push(featureName + ': ' + attrTypeIds.join(', '));
        });

        if (outdatedItems.length > 0) {
            const message = 'Enkelte vegobjekter av type ' + featureType.name + ' hadde utdaterte egenskapstyper:\n' + outdatedItems.join(', ') + '\nDisse egenskapene ble utelatt fra eksportert SOSI-fil';
            showInfoMessage(message);
        }
    });
};


export type DownloadSosi = (
    featureTypes: FeatureTypeSummary[],
    selectedFeatureTypeIdsWithValidOperations: FeatureTypeIdWithValidOperations,
    sosiForNvdb123: boolean,
    srid: string,
    destination: Destination,
    useProjectRef: boolean,
    useContractProjectRef: boolean,
    contractProjectRef: string,
    customProjectRef: string,
) => DownloadThunk;
export const downloadSosi: DownloadSosi = (
    featureTypes,
    selectedFeatureTypeIdsWithValidOperations,
    sosiForNvdb123,
    srid,
    destination,
    useProjectRef,
    useContractProjectRef,
    contractProjectRef,
    customProjectRef
) => async (dispatch, getState, serverHolder) => {

    const contractId = serverHolder.contractId;

    let projectRef: string;

    if (useProjectRef) {
        if (useContractProjectRef) {
            projectRef = contractProjectRef;
        } else {
            projectRef = customProjectRef;
        }
    }

    try {
        serverHolder.server.downloadFeaturesAsSosi(
            contractId, selectedFeatureTypeIdsWithValidOperations, sosiForNvdb123, srid, destination, projectRef
        );
    }

    catch (e) {}

    Object.keys(selectedFeatureTypeIdsWithValidOperations).forEach((featureTypeId) =>
        dispatch(notifyOutdatedFeatureAttributes(Number.parseInt(featureTypeId, 10), featureTypes))
    );
};
